import React from "react";
import styled from "styled-components";

import { Switch, Route } from "react-router-dom";

import qs from 'query-string';

import {
  BoxContainer,
  BoxItem,
  BoxItemImage,
  BoxItemTitle,
  BoxItemDescription,
  BoxItemStep,
  BoxItemLink,
  BoxFooter,
  BoxBarcodeWrapper,
  BoxText1,
  BoxText2,
  BoxText3,
  FooterImage,
} from "./layout";
import { getPageBasePaths } from "context/SiteSettingsContext/utils";

import barcodeSvg from "./assets/barcode.svg";
import macStep1Png from "./assets/mac-step1.png";
import macStep2Png from "./assets/mac-step2.png";
import macStep3Png from "./assets/mac-step3.png";
import macPrewPng from "./assets/mac-prew.png";
import winStep1Png from "./assets/win-step1.png";
import winStep2Png from "./assets/win-step2.png";
import winStep3Png from "./assets/win-step3.png";
import winPrewPng from "./assets/win-prew.png";
import linuxStep1Png from "./assets/linux-step1.png";
import linuxPrewPng from "./assets/linux-prew.png";
import unifiOsPng from "./assets/unifi-os.png";

export const Section = styled.div`
  position: relative;
  -webkit-font-smoothing: antialiased;
`;
const BoxBlock = styled.div``;

const BoxBlockHeader = styled.div`
  padding: 40px 0 10px 0;
`;
const BoxBlockDescription = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.02em;
  text-align: center;
  color: #6b6d76;
  padding: 0 10px;

  a {
    text-decoration: underline;
    color: #006fff;
  }
`;

const parsed = qs.parse(window.location.search)["v"];
const version = parsed ? parsed : `7.3.83`;

const LayoutComponent = ({ routes }) => {
  const getBoxHeader = (href) => {
    return (
      <BoxBlockHeader>
        <BoxBlockDescription>
          UniFi Network Server download will start automatically. If it doesn't
          start, you can <a href={href}>manually download UniFi</a>.
        </BoxBlockDescription>
      </BoxBlockHeader>
    );
  };

  const barCodeContent = (
    <div>
      <BoxText1>iOS and Android</BoxText1>
      <BoxText2>UniFi for your phone</BoxText2>
      <BoxText3>
        Manage your Network with UniFi Mobile Application for iOS or Android.
      </BoxText3>
      <BoxBarcodeWrapper>
        <img src={barcodeSvg} alt="linux barcode" />
        <span>
          Get the UniFi Application by scanning this code with your phone's
          camera.
        </span>
      </BoxBarcodeWrapper>
    </div>
  );

  return (
    <Section>
      <Switch>
        <Route
          path={getPageBasePaths("/download/unifi/mac/download-started")}
          exact
          render={() => {
            return (
              <BoxBlock>
                {getBoxHeader(`https://dl.ui.com/unifi/${version}/UniFi.pkg`)}
                <BoxContainer>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem>
                          <BoxItemStep>Step 1</BoxItemStep>
                          <BoxItemTitle>Open downloaded file</BoxItemTitle>
                          <BoxItemDescription>
                            To open the UniFi-Network-Server.dmg file, simply
                            navigate to the downloads list located at the bottom
                            left corner of this window and click on it.
                          </BoxItemDescription>
                          <BoxItemLink></BoxItemLink>
                          <BoxItemImage className="imageMac">
                            <img
                              src={macStep1Png}
                              alt="macOS step 1"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem>
                          <BoxItemStep>Step 2</BoxItemStep>
                          <BoxItemTitle>Install UniFi Server</BoxItemTitle>
                          <BoxItemDescription>
                            Move UniFi to the Applications folder using drag and
                            drop. You may need to enter the admin password.
                          </BoxItemDescription>

                          <BoxItemImage className="imageMac">
                            <img
                              src={macStep2Png}
                              alt="macOS step 2"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem>
                          <BoxItemStep>Step 3</BoxItemStep>
                          <BoxItemTitle>Launch UniFi Server</BoxItemTitle>
                          <BoxItemDescription>
                            To start the app, go to the Launchpad, type in
                            UniFi, and select the app.
                          </BoxItemDescription>

                          <BoxItemImage className="imageMac">
                            <img
                              src={macStep3Png}
                              alt="macOS step 3"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                    </div>
                  </div>
                </BoxContainer>
                <BoxContainer>
                  <BoxFooter>
                    <FooterImage
                      className="footerImage"
                      width="480"
                      height="271"
                      src={macPrewPng}
                      alt="macOS preview"
                    />
                    {barCodeContent}
                  </BoxFooter>
                </BoxContainer>
              </BoxBlock>
            );
          }}
        />
        <Route
          path={getPageBasePaths("/download/unifi/win/download-started")}
          exact
          render={() => {
            return (
              <BoxBlock>
                {getBoxHeader(
                  `https://dl.ui.com/unifi/${version}/UniFi-installer.exe`,
                )}
                <BoxContainer>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem style={{ maxHeight: `365px` }}>
                          <BoxItemStep>Step 1</BoxItemStep>
                          <BoxItemTitle>Open downloaded file</BoxItemTitle>
                          <BoxItemDescription>
                            To open the unifi.exe file, simply navigate to the
                            downloads list located at the bottom left corner of
                            this window and click on it.
                          </BoxItemDescription>
                          <BoxItemLink></BoxItemLink>
                          <BoxItemImage className="imageWin">
                            <img
                              src={winStep1Png}
                              alt="windows step 1"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem style={{ maxHeight: `365px` }}>
                          <BoxItemStep>Step 2</BoxItemStep>
                          <BoxItemTitle>Allow to Install</BoxItemTitle>
                          <BoxItemDescription>
                            Give permission to the UniFi Installation file to
                            install the application on your computer. This
                            application has been verified and is trusted.
                          </BoxItemDescription>

                          <BoxItemImage className="imageWin">
                            <img
                              src={winStep2Png}
                              alt="windows step 2"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                      <div className="col-xs-24 col-sm-8">
                        <BoxItem style={{ maxHeight: `365px` }}>
                          <BoxItemStep>Step 3</BoxItemStep>
                          <BoxItemTitle>Install UniFi Application</BoxItemTitle>
                          <BoxItemDescription>
                            Please wait for the installation process to
                            complete. UniFi will launch automatically once it's
                            finished.
                          </BoxItemDescription>

                          <BoxItemImage className="imageWin">
                            <img
                              src={winStep3Png}
                              alt="windows step 3"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                    </div>
                  </div>
                </BoxContainer>
                <BoxContainer>
                  <BoxFooter>
                    <FooterImage
                      className="footerImage"
                      width="480"
                      height="271"
                      src={winPrewPng}
                      alt="windows preview"
                    />
                    {barCodeContent}
                  </BoxFooter>
                </BoxContainer>
              </BoxBlock>
            );
          }}
        />
        <Route
          path={getPageBasePaths("/download/unifi/linux/download-started")}
          exact
          render={() => {
            return (
              <BoxBlock>
                {getBoxHeader(
                  `https://dl.ui.com/unifi/${version}/unifi_sysvinit_all.deb`,
                )}
                <BoxContainer>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-xs-24 col-sm-9 noPadingRight">
                        <BoxItem
                          className="boxLinuxText"
                          style={{ maxHeight: `225px` }}
                        >
                          <BoxItemStep>
                            UniFi Network Server for Linux
                          </BoxItemStep>
                          <BoxItemTitle>
                            Install and Updating Steps
                          </BoxItemTitle>
                          <BoxItemDescription>
                            Follow these step-by-step instructions to install
                            and update UniFi on your Linux machine.
                          </BoxItemDescription>
                          <BoxItemLink>
                            {/*<BoxItemUrl
                                                            href=''>
                                                            Installation Guidelines
                                                        </BoxItemUrl>*/}
                          </BoxItemLink>
                        </BoxItem>
                      </div>
                      <div className="col-xs-24 col-sm-15 noPadingLeft">
                        <BoxItem
                          className="boxLinuxImg"
                          style={{ maxHeight: `225px` }}
                        >
                          <BoxItemImage className="imageLinux">
                            <img
                              src={linuxStep1Png}
                              alt="linux step 1"
                            />
                          </BoxItemImage>
                        </BoxItem>
                      </div>
                    </div>
                  </div>
                </BoxContainer>
                <BoxContainer>
                  <BoxFooter>
                    <FooterImage
                      className="footerImage"
                      width="480"
                      height="271"
                      src={linuxPrewPng}
                      alt="linux preview"
                    />
                    {barCodeContent}
                  </BoxFooter>
                </BoxContainer>
              </BoxBlock>
            );
          }}
        />
        <Route
          path={getPageBasePaths("/download/unifi/unifi-os/download-started")}
          exact
          render={() => {
            return (
              <BoxBlock>
                {getBoxHeader(
                  `https://dl.ui.com/unifi/${version}/unifi-uos_sysvinit.deb`,
                )}
                <BoxContainer>
                  <BoxFooter>
                    <FooterImage
                      className="footerImage"
                      width={159}
                      src={unifiOsPng}
                      alt="Unifi OS preview"
                    />
                    {barCodeContent}
                  </BoxFooter>
                </BoxContainer>
              </BoxBlock>
            );
          }}
        />
        <Route
          path={getPageBasePaths(
            "/download/unifi/unifi-os-native/download-started",
          )}
          exact
          render={() => {
            return (
              <BoxBlock>
                {getBoxHeader(
                  `https://dl.ui.com/unifi/${version}/unifi-native_sysvinit.deb`,
                )}
                <BoxContainer>
                  <BoxFooter>
                    <FooterImage
                      className="footerImage"
                      width={159}
                      src={unifiOsPng}
                      alt="Unifi OS Native preview"
                    />
                    {barCodeContent}
                  </BoxFooter>
                </BoxContainer>
              </BoxBlock>
            );
          }}
        />
      </Switch>
    </Section>
  );
};

export default LayoutComponent;
